import { createContext } from 'react';

export type Language = 'en' | 'fr';

type I18nContextType = {
  toggleLanguage: () => void;
};

export const I18nContext = createContext<I18nContextType | null>(null);
